import { IconProps } from './IconProps';

export const FastForwardWhite = (props: IconProps) => {
  return (
    <svg
      style={props.style}
      className={props.className}
      width="25"
      height="16"
      viewBox="0 0 25 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.09715 15.7624C0.463731 16.2362 0.000313613 15.9797 0.000313613 15.1865L0.000313613 0.810507C0.000313613 0.0251681 0.463553 -0.236456 1.09715 0.234626L10.2589 7.13491C10.5558 7.31987 10.7374 7.64399 10.7402 7.99382C10.7428 8.34367 10.5662 8.67053 10.2718 8.86003L1.09715 15.7624Z"
        fill="white"
      />
      <path
        d="M14.8374 15.7624C14.204 16.2362 13.7405 15.9797 13.7405 15.1865L13.7405 0.810507C13.7405 0.0251681 14.2038 -0.236456 14.8374 0.234626L23.9991 7.13491C24.2962 7.31987 24.4777 7.64399 24.4804 7.99382C24.483 8.34367 24.3064 8.67053 24.0123 8.86003L14.8374 15.7624Z"
        fill="white"
        fillOpacity="0.4"
      />
    </svg>
  );
};

